const MAX_ATTEMPTS = 5
const INTERVAL = 500

interface Options {
    maxAttempts: number
    interval: number
}

const defaultOptions: Options = {
    interval: INTERVAL,
    maxAttempts: MAX_ATTEMPTS,
}

export function waitFor(
    identifier: string,
    onReady: () => void,
    options: Options = defaultOptions
) {
    const { maxAttempts, interval } = Object.assign(options, defaultOptions)
    let attempts = 0
    return (function check() {
        ++attempts
        if (identifier in window) {
            onReady()
        } else {
            if (attempts > maxAttempts) return
            setTimeout(check, interval)
        }
    })()
}
